"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _EditOutlined = _interopRequireDefault(require("@material-ui/icons/EditOutlined"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _date = require("@jobmatchme/utils/es/date");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _SingleComponent = _interopRequireDefault(require("../SingleComponent"));

var _useOurTranslation = _interopRequireWildcard(require("../../../utils/useOurTranslation"));

var _ProfileProvider = require("../../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, (0, _extends2.default)({
    className: _styleModule.default.skeleton
  }, props));
};

var displayLocation = function displayLocation(locationValue) {
  return locationValue.name;
};

var getDisplayValue = function getDisplayValue(value, componentConfiguration, t, item, getDefault, identifier) {
  var valueType = componentConfiguration.valueType;
  var options = componentConfiguration.options;
  var valueName = componentConfiguration.valueName;

  if (valueName === 'workTimes') {
    valueType = 'WorkTimes';
  }

  if (valueType === 'String' && componentConfiguration.component === 'SingleChoice') {
    valueType = 'Array';
  }

  var calculateAge = function calculateAge(birthYear) {
    var currentYear = new Date().getFullYear();
    var diff_yy = currentYear - birthYear;
    return diff_yy;
  };

  switch (valueType) {
    case 'LocationType':
      return displayLocation(value);

    case 'NumberRange':
      return "".concat(value.minimum, "\u20AC - ").concat(value.maximum, "\u20AC");

    case 'LanguagesArray':
    case 'Array':
      var valueArray = value || [];
      var fromParamType = componentConfiguration.fromParamType ? componentConfiguration.fromParamType : function (a) {
        return a;
      };

      if (!Array.isArray(valueArray)) {
        valueArray = [valueArray];
      }

      return valueArray.map(fromParamType).filter(Boolean).map(function (value) {
        return t(options[value]);
      }).join(', ');

    case 'Boolean':
      var answer = 'false';

      if (value === true) {
        answer = 'true';
      } else if (!value) {
        answer = 'false';
      } else {
        answer = 'false';
      }

      return t(options[answer]);

    case 'String':
      {
        if (typeof valueName === 'undefined') {
          return '';
        }

        return value || '';
      }

    case 'DescriptionString':
      {
        if (typeof valueName === 'undefined') {
          return '';
        } else if (valueName === 'names' && !value[componentConfiguration.identifier]) {
          return getDefault(valueName, identifier);
        }

        return value[componentConfiguration.identifier] || '';
      }

    case 'DiagnosticArray':
      return t(componentConfiguration.translations.label);

    case 'WorkTimes':
      return value ? value.map(function (e) {
        return t(options[e]);
      }).join(', ') : '';

    case 'Number':
      if (item === 'birthYear') {
        return value ? value + ' (' + calculateAge(value) + '  Jahre)' : '';
      }

      if (item === 'availabilityDate') {
        return value ? (0, _date.formatDate)(value) : '---';
      }

      if (item === 'workExperience') {
        if (value === null) {
          return t(options[0]);
        }

        return value === 0 || value > 0 ? t(options[value]) : '';
      }

      break;

    default:
      return '';
  }
}; // Dynamic Icon creations


var showIcon = function showIcon(icon, index, valueIsSet) {
  var iconPool = {
    People: require('@material-ui/icons/Group').default,
    DriveEta: require('@material-ui/icons/DriveEta').default,
    LocationOn: require('@material-ui/icons/Room').default,
    Business: require('@material-ui/icons/Business').default,
    LocalHospital: require('@material-ui/icons/LocalHospital').default,
    WatchLater: require('@material-ui/icons/WatchLater').default,
    Help: require('@material-ui/icons/Help').default,
    MonetizationOn: require('@material-ui/icons/MonetizationOn').default,
    School: require('@material-ui/icons/School').default,
    Update: require('@material-ui/icons/Update').default,
    InsertInvitation: require('@material-ui/icons/InsertInvitation').default,
    Today: require('@material-ui/icons/Today').default
  };
  var Icon = iconPool[icon] || (valueIsSet ? _CheckCircle.default : _Error.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
    className: "".concat(_styleModule.default.icon, " ").concat(valueIsSet ? _styleModule.default.active : _styleModule.default.notActive)
  }, 'icn' + iconPool[icon] + index);
};

var EditItem = function EditItem(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      item = _ref.item,
      handlePropertySave = _ref.handlePropertySave,
      notEmpty = _ref.notEmpty,
      initiallyOpen = _ref.initiallyOpen,
      _ref$bypassDisabled = _ref.bypassDisabled,
      bypassDisabled = _ref$bypassDisabled === void 0 ? false : _ref$bypassDisabled,
      _ref$showLoader = _ref.showLoader,
      showLoader = _ref$showLoader === void 0 ? false : _ref$showLoader;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);
  var appT = (0, _useOurTranslation.default)("profile-components:Edit");
  var profile = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  var profileActions = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext);
  var getDefault = profileActions.getDefault;
  var identifier = config.identifier;

  var _useState = (0, _react.useState)(initiallyOpen && initiallyOpen === config.valueName),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showEditPage = _useState2[0],
      setShowEditPage = _useState2[1];

  var handleRevert = function handleRevert() {
    profileActions.revert();
    setShowEditPage(false);
  };

  var handleOpen = function handleOpen() {
    return !disabled && setShowEditPage(true);
  };

  var handlePropertySaveAndClose = function handlePropertySaveAndClose(valueName) {
    handlePropertySave(valueName);
    setShowEditPage(false);
  };

  var lineKey = (item || {}).componentConfiguration;
  var isDisabled = (item || {}).disabled instanceof Function ? item.disabled(profile[config.valueName].value) : (item || {}).disabled;
  var disabled = !bypassDisabled && Boolean(isDisabled);
  var displayValue = showLoader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
    variant: "text",
    width: "200px"
  }) : getDisplayValue(profile[config.valueName].value, config, t, lineKey, getDefault, identifier); // This is a hard toggle on weather or not to display the icons from the configuration in the edit view or just show the plain check or error icons

  var DISPLAY_ICONS = false;
  var Icon = DISPLAY_ICONS ? showIcon(config.icon, lineKey, !!displayValue) : notEmpty ? _CheckCircle.default : _Error.default;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
      className: _styleModule.default.divider
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 1,
      justify: "space-between",
      alignItems: "center",
      className: "".concat(_styleModule.default.line, " ").concat(notEmpty ? _styleModule.default.set : _styleModule.default.notSet, " ").concat(disabled ? _styleModule.default.disabledLine : ''),
      onClick: handleOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 1,
        children: showLoader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
          variant: "circle",
          width: "1rem",
          height: "1rem"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
          className: "".concat(_styleModule.default.icon)
        }, "".concat(lineKey, "Icon").concat(config.icon))
      }, "".concat(lineKey, "Grid").concat(config.icon)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 9,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
          component: "p",
          align: "left",
          className: "".concat(disabled ? _styleModule.default.disabled : '', " ").concat(_styleModule.default.text),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.editElementLabel,
            children: showLoader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
              variant: "text",
              width: "40%"
            }) : t(config.translations.label)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.editElement,
            children: displayValue || appT('emptyValuePlaceholder')
          })]
        })
      }, "".concat(lineKey, "GridDisplay")), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 1,
        children: disabled || showLoader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          "aria-label": "edit",
          size: "small",
          className: "".concat(_styleModule.default.editIcon),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditOutlined.default, {}, "".concat(lineKey, "IconEdit"))
        })
      }, "".concat(lineKey, "GridEdit"))]
    }), showEditPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleComponent.default, {
      config: config,
      open: showEditPage,
      handleRevert: handleRevert,
      handlePropertySave: handlePropertySaveAndClose
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(EditItem);

exports.default = _default;